import React, { useState, useEffect } from 'react';
import Registry from '../../../registry';

import './CookieConsentBanner.scss';
import {getCookie} from "../../../utils";

function setCookie(name, value, seconds) {
    const expires = new Date(Date.now() + seconds * 1000).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; expires=${expires}`;
}

export default function CookieConsentBanner() {

    const lang = Registry.get('locale');

    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const isBot = /bot|crawl|slurp|spider/i.test(navigator.userAgent);
        const consent = getCookie('cookieConsent');
        if (!consent && !isBot) setVisible(true);
    }, []);

    const setConsent = (value) => {
        let cookieDuration = value === 'accepted' ? 365*24*86400 : 7*24*86400
        setCookie('cookieConsent', value, cookieDuration);
        setVisible(false);
        if (value === 'accepted') window.location.reload();
    };

    if (!visible) return null;

    return (
        <div className={'cookieConsentBanner'}>
            <div className={'desktopCookieButton'}>
                <button className="ui-button primary" onClick={() => setConsent('rejected')}>
                    {lang.Refuse}
                </button>
            </div>

            <div>{lang.this_site_uses_cookies}</div>

            <div className={'desktopCookieButton'}>
                <button className="ui-button primary" onClick={() => setConsent('accepted')}>
                    {lang.Accept}
                </button>
            </div>

            <div className={'cookieButtons mobileCookieButtons'}>
                <button className="ui-button primary" onClick={() => setConsent('rejected')}>{lang.Refuse}</button>
                <button className="ui-button primary" onClick={() => setConsent('accepted')}>{lang.Accept}</button>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/CookieConsentBanner/CookieConsentBanner.js